import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { sessionSelectors } from 'modules/session';

const MOSS_AVAILABLE_COMPANY_IDS: number[] = [];
const APPLICATION_ID = '640aec75-4057-40bb-a84b-ec8c39462a12';

const useMossSdk = () => {
  const currentUser = useSelector(sessionSelectors.currentUser);
  const userId = currentUser?.id;
  const companyId = currentUser?.company_id;

  useEffect(() => {
    if (!userId || companyId === undefined || !MOSS_AVAILABLE_COMPANY_IDS.includes(companyId)) {
      return;
    }
    // Spendit sanitization script
    const spenditSanitizationScript = function (doc: Document) {
      const attemptToMarkElement = () => {
        const xpath = '//*[@id="root"]/div/div[1]';
        try {
          const result = doc.evaluate(xpath, doc, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
          const elementToIgnore = result.singleNodeValue as Element;

          if (elementToIgnore) {
            console.log('[Spendit] Found and marking element by XPath as irrelevant:', elementToIgnore);
            elementToIgnore.setAttribute('data-clippy-ignore', 'true');
            return true;
          }
          return false;
        } catch (error) {
          console.error('[Spendit] Error evaluating XPath for marking element:', error);
          return false;
        }
      };

      if (attemptToMarkElement()) {
        console.log('[Spendit] Target for ignore marked on initial attempt.');
      } else {
        console.log('[Spendit] Target for ignore not found initially, setting up MutationObserver.');
        const observer = new MutationObserver((mutationsList, obs) => {
          if (attemptToMarkElement()) {
            console.log('[Spendit] Target for ignore marked after DOM mutation.');
            obs.disconnect();
          }
        });
        observer.observe(doc.body, { childList: true, subtree: true });
        setTimeout(() => {
          observer.disconnect();
        }, 10000);
      }

      console.log('[Spendit] Page sanitization script setup finished.');
    };

    // Configure Moss SDK - only language and sanitization
    window.mossSettings = {
      language: 'ko',
      pageSanitizationScript: spenditSanitizationScript,
    };

    // Load the Moss SDK script
    const script = document.createElement('script');
    script.src = `https://cdn.viamoss.ai/moss-sdk@latest.min.js?applicationId=${APPLICATION_ID}&userId=${userId}`;
    document.head.appendChild(script);

    console.log('[CRA] Moss SDK loaded');
  }, [companyId, userId]);
};

export default useMossSdk;
